/**
 * @file EventBus.js
 * @desc 事件管理
 * @author YongZhang<zhangyong06@baidu.com>
 */
'use strict';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default {
    namespaced: true,
    state: {
        eventBus: []
    },
    getters: {
        onEvent(state) {
            return function (name) {
                let index = state.eventBus.findIndex(item => {
                    return item.name === name;
                });
                if (state.eventBus.length > 0 && index >= 0) {
                    let result = Object.assign({}, state.eventBus[index]);
                    return result;
                }
                return null;
            };
        }
    },
    mutations: {

        /**
         * 触发事件
         *
         * @param {Object} state 状态树
         * @param {Object} event 事件信息
         * @param {Object} event.name 事件名
         * @param {Object} event.payload 事件附加数据
         */
        emitEvent(state, event) {
            if (event && event.name) {
                event.payload = !event.payload ? '' : event.payload;
                event.time = new Date().getTime();
                state.eventBus.push(event);
            }
        },

        /**
         * 消费事件
         *
         * @param {Object} state 状态树
         * @param {Object} event 事件信息
         * @param {Object} event.name 事件名
         * @param {Object} event.time 事件时间戳，用来移除指定事件
         */
        consumeEvent(state, event) {
            const {name, time} = event || {};
            if (name) {
                let index = state.eventBus.findIndex(item => {
                    if (event.time) {
                        return item.name === name && item.time === time;
                    }
                    return item.name === name;
                });
                const eventBus = [...state.eventBus];
                eventBus.splice(index, 1);
                state.eventBus = eventBus;
            }
        }
    }
};